import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const FarmerQualityCheckDetailReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [qualityParamter, setqualityParamter] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/qualityCheckReport/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("counts", data);

        var i = 0;
        var newList = [];
        var cropnameList = [];

        var procurementData = data;
        var parametrList = [];
        if (procurementData.length > 0) {
          do {
            var procurementitem = procurementData[i];
            var strfieldQc = JSON.stringify(procurementitem.fieldQc);

            var fieldQc = JSON.parse(JSON.parse(strfieldQc));
            var strqualityCheckParameters = JSON.stringify(
              fieldQc.qualityCheckParameters
            );

            var qualityCheckParameters = JSON.parse(
              JSON.parse(strqualityCheckParameters)
            );
            var j = 0;
            do {
              var paralist = parametrList.filter(
                (item) =>
                  item == qualityCheckParameters[j].qualityCheckParameter
              );
              if (paralist.length == 0) {
                parametrList.push(
                  qualityCheckParameters[j].qualityCheckParameter
                );
              }

              j++;
            } while (qualityCheckParameters.length > j);

            var QCPList = [];
            j = 0;

            do {
              var paralist = qualityCheckParameters.filter(
                (item) => item.qualityCheckParameter == parametrList[j]
              );
              if (paralist.length > 0) {
                QCPList.push(paralist[0].observation);
              }

              j++;
            } while (parametrList.length > j);

            newList = newList.concat({
              linesrno: j + 1,
              cropPlotId: procurementitem.cropPlotId,
              plotId: procurementitem.plotId,
              cropId: procurementitem.cropId,
              varietyId: procurementitem.varietyId,
              fieldExecutiveId: procurementitem.fieldExecutiveId,
              fieldExecutiveName: procurementitem.fieldExecutiveName,
              regionId: procurementitem.regionId,
              regionName: procurementitem.regionName,
              farmerNo: procurementitem.farmerNo,
              farmerName: procurementitem.farmerName,
              plotName: procurementitem.plotName,
              plotArea: procurementitem.plotArea,
              plotAreaUnit: procurementitem.plotAreaUnit,
              cropName: procurementitem.cropName,
              cropTypeName: procurementitem.cropTypeName,
              varietyName: procurementitem.varietyName,
              sowingDate: procurementitem.sowingDate,
              pruningDate: procurementitem.pruningDate,
              harvestingDate: procurementitem.harvestingDate,
              surveyNumberGutNumber: procurementitem.surveyNumberGutNumber,
              fieldQcDate: fieldQc.fieldQcDate,
              mrlStatus: fieldQc.mrlStatus,
              ratingValue: fieldQc.ratingValue,
              qualityCheckParameters: QCPList,
            });
            i++;
          } while (procurementData.length > i);
        }
        //console.log("inewList", newList);
        setData(newList);

        //console.log("parametrList", parametrList);
        setqualityParamter(parametrList);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, [getprocurementData]);

  const fieldsToExport = [
    "farmerName",
    "farmerNo",
    "fieldExecutiveName",
    "regionName",
    "plotName",

    "cropTypeName",
    "cropName",
    "varietyName",
    "plotArea",
    "plotAreaUnit",
    "sowingDate",
    "pruningDate",
    "surveyNumberGutNumber",
    "estimationDate",
    "estimation",
    "estimationUnit",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Executive Name",
    "Region Name",
    "Plot Name",
    "crop Type",
    "Crop Name",
    "Variety Name",
    "Plot Area",
    "Unit",
    "Sowing Date",
    "Pruning Date",
    "Survey No",
    "Estimation Date",
    "Estimation",
    "Estimation Unit",
  ];

  const handleExportExcel = () => {
    const filename = "YieldEstimationsReport.xlsx";
    //console.log(fieldsToExport,customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              {" "}
              Quality Check Detail Reports
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Region</label>
                  <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      var regid = 0;

                      if (e.target.value != "--Select--") {
                        regid = e.target.value;
                      }
                      setRegionId(regid);
                      EmployeeDetail(regid);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option
                          key={x.regionId}
                          user-id={x.regionId}
                          value={x.regionId}
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              {/* <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                
                <i className="fas fa-file-excel"></i>
              </button> */}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Farmer Name</th>
                          <th>Farmer Code</th>
                          <th>Executive Name</th>
                          <th> Region Name</th>
                          <th> Plot Name</th>
                          <th> crop Type</th>
                          <th> Crop Name</th>
                          <th> Variety Name</th>
                          <th> Plot Area</th>
                          <th> Unit</th>
                          <th> Sowing Date </th>
                          <th> Pruning Date</th>
                          <th> Survey No </th>
                          <th>Filed Quality Date</th>
                          <th>MRL Status </th>
                          <th>Rating </th>
                          <th colSpan={qualityParamter.length}>
                            Quality Check{" "}
                          </th>
                        </tr>

                        <tr className="tableheaderrowview">
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th> <th></th> <th></th> <th></th>
                          <th></th> <th></th> <th></th> <th></th>
                          <th></th>
                          <th></th>
                          {qualityParamter &&
                            qualityParamter.map((itm, i) => {
                              return <th>{itm} </th>;
                            })}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.fieldExecutiveName}</td>
                                <td>{itm.regionName}</td>
                                <td>{itm.plotName}</td>

                                <td>{itm.cropTypeName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>

                                <td> {itm.plotArea} </td>
                                <td> {itm.plotAreaUnit} </td>
                                <td> {itm.sowingDate} </td>
                                <td> {itm.pruningDate} </td>

                                <td> {itm.surveyNumberGutNumber} </td>
                                <td> {itm.fieldQcDate} </td>
                                {/* <td> {itm.batch} </td> */}
                                <td> {itm.mrlStatus} </td>
                                <td> {itm.ratingValue} </td>
                                {itm.qualityCheckParameters &&
                                  itm.qualityCheckParameters.map((itQ, l) => {
                                    return <td>{itQ} </td>;
                                  })}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerQualityCheckDetailReport;
